import {
  Box,
  ListItemIcon,
  Popover,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";
import { useReduxState } from "../../../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../../../configuration/reduxStoreConfig";
import {
  ContainerNameBasket,
  StyledList,
  StyledListItem,
  StyledListItemButton,
  TextBasket,
  TransferBasketTooltipBox,
} from "./AppBasketMenuList.styles";
import { AppIconsShieldFilled } from "../../../AppIcons";
import { AddBasketButton } from "./AddBasketButton";
import { MoreVert } from "@mui/icons-material";
import { Basket } from "../../../../../explorer/types";
import {
  formatDateByLocale,
  formatDateTimeByLocale,
} from "../../../../../explorer/helpers/CommonHelper";
import useLanguages from "../../../../../explorer/hooks/useLanguages";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import AppIconsTransferBasket from "../../../AppIcons/AppIconsTransferBasket";

type Props = {
  setAnchorEl: (_p: null | HTMLElement) => void;
  anchorEl: null | HTMLElement;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  isMenuOpen: boolean;
  menuId: string;
  handleMenuClose: () => void;
  handleMenuCloseOnChange: (basket: Basket) => void;
  setBasketActionResultSnackbarState: (_p: any) => void;
  setCreateDialogOpen: (_p: boolean) => void;
  handleActivateActionMenu: (
    _event: any,
    baskedId: number,
    basketName: string,
    basketSelected: boolean
  ) => void;
};
export const AppBasketMenuList = (props: Readonly<Props>) => {
  const [baskets, setBaskets] = useReduxState<Basket[]>(
    reduxStoreConfig.basketBaskets
  );
  const lang = useLanguages().currentLanguage;
  const { t } = useTranslation();
  // const formatDate = (dateString?: string) => {
  //     if (!dateString) return;

  //     const date = new Date(dateString);
  //     const options: Intl.DateTimeFormatOptions = {
  //         day: "2-digit",
  //         month: "2-digit",
  //         year: "numeric",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         second: "2-digit",
  //         hour12: false,
  //     };
  //     return new Intl.DateTimeFormat("it-IT", options)
  //         .format(date)
  //         .replace(", ", " - ");
  // };

  return (
    <Popover
      className="AppSiteSelector-menu"
      anchorEl={props.anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      id={props.menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={props.isMenuOpen}
      onClose={props.handleMenuClose}
    >
      <StyledList>
        {(props.loading || baskets === undefined ? [] : baskets).map(
          (x: Basket, index: number) =>
            !props.loading ? (
              <StyledListItem
                key={"blelem_" + x.id}
                onClick={() => props.handleMenuCloseOnChange(x)}
                className={x.selected ? "selected" : ""}
                secondaryAction={
                  <Box>
                    {(x.isSent || x.isReceived) && (
                      <Tooltip
                        disableInteractive={true}
                        title={x.transferInfo && <TransferInfo basket={x} />}
                      >
                        <Box>
                          <AppIconsTransferBasket />
                        </Box>
                      </Tooltip>
                    )}
                    <MoreVert
                      onClickCapture={(event) => {
                        return props.handleActivateActionMenu(
                          event,
                          x.id!,
                          x.name!,
                          !x.selected
                        );
                      }}
                      color={x.selected ? "inherit" : "primary"}
                    />
                  </Box>
                }
              >
                <StyledListItemButton>
                  <ContainerNameBasket>
                    <ListItemIcon sx={{ alignItems: "center" }}>
                      {x.selected && <AppIconsShieldFilled />}
                    </ListItemIcon>
                    <TextBasket inset>
                      {x.creationDate && (
                        <>{formatDateByLocale(x.creationDate, lang)}</>
                      )}
                      <Tooltip title={x.name}>
                        <span>{x.name}</span>
                      </Tooltip>
                    </TextBasket>
                  </ContainerNameBasket>
                </StyledListItemButton>
              </StyledListItem>
            ) : (
              <Skeleton key={index} variant="circular" width={20} height={20} />
            )
        )}
      </StyledList>

      <AddBasketButton
        setLoading={props.setLoading}
        setBasketActionResultSnackbarState={
          props.setBasketActionResultSnackbarState
        }
        setCreateDialogOpen={props.setCreateDialogOpen}
      />
    </Popover>
  );
};

export const TransferInfo = (props: { basket: Basket }) => {
  const basket = props.basket;
  const { t } = useTranslation();
  const lang = useLanguages().currentLanguage;
  
  const isReceived = basket.isReceived && basket.transferInfo?.receivedBy;
  const isSent = basket.isSent && basket.transferInfo?.sentTo;

  const renderTransferInfo = (
    transferredLabel: string,
    userFirstName: string,
    userLastName: string,
    customerCode: string,
    customerName: string,
    tranferDate: string
  ) => {
    return (
      <Box>
        <Typography>
          <b>{t(transferredLabel)}</b>
          <>{`: ${userFirstName}, ${userLastName}`}</>
        </Typography>
        <Typography>
          <b>{t("basket.information")}</b>
          <>{`: ${customerCode} - ${customerName}`}</>
        </Typography>
        <Typography>
          <b>{t("basket.dateTransfer")}</b>
          <>{`: ${formatDateTimeByLocale(tranferDate || "", lang)}`}</>
        </Typography>
      </Box>
    );
  };

  return (
    <TransferBasketTooltipBox>
      {isReceived &&
        renderTransferInfo(
          "basket.transferredFrom",
          basket.transferInfo?.receivedBy?.userFirstName ?? "",
          basket.transferInfo?.receivedBy?.userLastName ?? "",
          basket.transferInfo?.receivedBy?.customerCode ?? "",
          basket.transferInfo?.receivedBy?.customerName ?? "",
          basket.transferInfo?.receivedBy?.tranferDate ?? ""
        )}
      {isReceived && isSent && <hr />}
      {isSent &&
        renderTransferInfo(
          "basket.transferredTo",
          basket.transferInfo?.sentTo?.userFirstName ?? "",
          basket.transferInfo?.sentTo?.userLastName ?? "",
          basket.transferInfo?.sentTo?.customerCode ?? "",
          basket.transferInfo?.sentTo?.customerName ?? "",
          basket.transferInfo?.sentTo?.tranferDate ?? ""
        )}
    </TransferBasketTooltipBox>
  );
};
